import React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

const StyledGroup = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-right: 16px;
  margin-left: 16px;
`;

const JayaItem = [
  {
    title: "PT. Pembangunan Jaya",
    image: "/image/1.Jaya-Pembangunan.png",
    redirect: "http://www.pembangunanjaya.id/id-id",
  },
  {
    title: "PT Jaya Real Property Tbk.",
    image: "/image/2.Jaya-Real-Property.png",
    redirect: "http://jayaproperty.com/",
  },
  {
    title: "PT Jaya Konstruksi ",
    subTitle: "Manggala Pratama, Tbk",
    image: "/image/3.Jaya-Kon.png",
    redirect: "http://jayakonstruksi.com/",
  },
  {
    title: "PT Taman Impian Jaya Ancol.",
    image: "/image/5.Jaya-Ancol.png",
    redirect: "https://www.ancol.com/",
  },
  {
    title: "Universitas",
    subTitle: "Pembangunan Jaya",
    image: "/image/4.Jaya-Upj.png",
    redirect: "https://www.upj.ac.id/",
  },
  {
    title: "Global Jaya School",
    image: "/image/6.Jaya-Global-School.png",
    redirect: "http://www.globaljaya.com/id/index.php",
  },
];

const JayaGroup = ({ isId }: any) => {
  return (
    <div
      style={{
        textAlign: "center",
        backgroundColor: "#F0F0F0",
        padding: "4rem 0",
      }}
    >
      <Typography color="primary" variant="h4" style={{ marginBottom: "2rem" }}>
        {isId ? "Group Kami" : "Our Group"}
      </Typography>
      <StyledGroup>
        {JayaItem.map((row, i) => (
          // <Fade bottom key={i}>
          <div key={row.title} style={{ margin: "1rem" }}>
            <Typography color="textPrimary">{row.title}</Typography>
            {row.subTitle && (
              <Typography color="textPrimary">{row.subTitle}</Typography>
            )}
            <a
              target="_blank"
              rel="noreferrer"
              style={{ display: "block", marginTop: "1rem" }}
              href={row.redirect}
            >
              <img src={row.image} width={150} alt={row.title} />
            </a>
          </div>
          // </Fade>
        ))}
      </StyledGroup>
    </div>
  );
};

export default JayaGroup;
